module.exports = __webpack_public_path__ + "img/幸运抽签.f42fde12.svg";